export default (api) => {
  api.line_notify = {
    public: {
    },
    admin: {
      send: (params = {}) => api.request({
        url: `/api/admin/line-notify/send`,
        type: 'post',
        params,
      }),
    },
  }
}